














import { Component, Prop, Vue } from 'vue-property-decorator';
import { Warning } from '@/pages/profile/components';
import { Card } from '../../blocks';
import { Notifications } from '@/services';
import { INotificationsNotifications } from './types';

@Component({
  components: {
    Warning,
    Card,
  },
})
export default class NotificationsNotifications
  extends Vue
  implements INotificationsNotifications {
  @Prop({ type: Array, default: () => [] })
  readonly notifications!: Array<Notifications>;

  postData(id: string) {
    if (id) this.$emit('postData', id);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/notification/views/notifications/NotificationsNotifications.vue